import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../utils/Loader';
import Select from 'react-select';
import { fetchReportRevenue, setReportsFilters } from '../../action';
import PointsSelect from '../utils/PointsSelect';
import DateSelect from '../utils/DateSelect';
import moment from 'moment';
import SortButton from '../utils/SortButton';
import { isEmpty } from 'lodash';
import { fetchFilials } from '../../action/handbook';
import { roleId } from '../../constants/app';
import { fetchUsersByRole } from '../../action/user';
import { utils, writeFileXLSX } from 'xlsx';
import ErrorContainer from '../utils/ErrorContainer';
import MultiSelect from '../utils/MultiSelect';

const styles = {
    loading: {
        minHeight: '200px',
        display: 'flex',
        justifyContent: 'center'
    }
};

function FirstLvlRow ({item, firstLvl, color='#d5d4ff61', marginLeft = '0px' }) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);    
    const renderFirstLvl = firstLvl && firstLvl !== 'none';

    const handleClick = () => {
        if (!renderFirstLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={renderFirstLvl ? { cursor: 'pointer', backgroundColor: color } : { backgroundColor: color }}>
            {renderFirstLvl && <td className='kt-datatable__cell' style={{ width: '12px' }}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: '100px'}}></td>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span style={renderFirstLvl ? { marginLeft: '15px' } : { marginLeft: marginLeft }}>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '250px'}}><span>{item.renderTime || 0}</span></td>
        </tr>
        {renderFirstLvl && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={null} color='#bbbaff61' marginLeft='75px' />)
        }
        </>
    )
}

function ItemRow ({item, firstLvl, secondLvl}) {
    const [ showFirstLvl, setShowFirstLvl ] = useState(false);
    const renderFirstLvl = firstLvl && firstLvl !== 'none' && !isEmpty(item.detailData);
    const renderSecondLvl = !renderFirstLvl && secondLvl && secondLvl !== 'none' && !isEmpty(item.detailData);

    const handleClick = () => {
        if (!renderFirstLvl && !renderSecondLvl) return;
        setShowFirstLvl(!showFirstLvl);
    }

    return (
        <>
        <tr onClick={handleClick} className='kt-datatable__row' style={(renderFirstLvl || renderSecondLvl) ? { cursor: 'pointer' } : {}}>
            {(renderFirstLvl || renderSecondLvl) && <td className='kt-datatable__cell' style={{ width: '12px'}}><i className={`kt-menu__ver-arrow la la-angle-${showFirstLvl ? 'up' : 'down'}`} style={{ fontSize: '0.8rem' }}/></td>}
            <td className='kt-datatable__cell' style={{ width: '100px'}}><span>{item.stage}</span></td>
            <td className='kt-datatable__cell' style={{ width: 'auto'}}><span>{item.name}</span></td>
            <td className='kt-datatable__cell' style={{ width: '250px'}}><span>{item.renderTime || 0}</span></td>
        </tr>
        {(renderFirstLvl || renderSecondLvl) && showFirstLvl && 
            Object.entries(item.detailData).map(([key, item]) => <FirstLvlRow item={item} firstLvl={renderSecondLvl ? null : secondLvl} marginLeft='60px'/>)
        }
        </>
    )
}

const renderAdress = (item) => {
    if (!item) return 'Не определен';
    return `${item.city.name ? item.city.name : '---'}, ${item.street}, ${item.house}`;
};

const firstLvlOptions = [
    { label: 'Нет', value: 'none' },
    { label: 'Филиалы', value: 'points' },
    { label: 'Дни недели', value: 'daysweek' },
];

const dateOptions = [
    { label: 'День', value: 'day', notRender: [ 'year' ], option: 'date' },
    { label: 'Неделя', value: 'week', notRender: [ 'day', 'week' ], option: 'date' },
    { label: 'Месяц', value: 'month', notRender: [ 'day', 'week' ], option: 'date' },
];

export default function StagesOrders() {
    const data = useSelector(state => state.reports.stagesOrders);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const pointLoading = useSelector(state => state.loaders.filials);

    const { result, filters, loading } = data;
    const [ regionalDirectors, setRegionalDirectors ] = useState([]);
    const [ _sort, setSort ] = useState({ field: 'stage', sort: 'ASC'});
    const [ renderFilters, setRenderFilters ] = useState(filters);

    const dispatch = useDispatch();

    const [ renderDetail, setRenderDetail ] = useState({
        firstLvl: {label: 'Нет', value: 'none'},
        secondLvl: { label: 'Нет', value: 'none' },
    });

    useEffect(() => {
        const getData = async () => {
            const regDirs = await dispatch(fetchUsersByRole({ role: roleId.regionalDirector }));
            const resultDirs = regDirs.map((dir) => ({ value: dir.id, label: dir.name ? dir.name : dir.username, points: dir.points })).sort((a, b) => a.label.localeCompare(b.label, 'ru'));
            setRegionalDirectors(resultDirs);
            if (!pointLoading && (isEmpty(points) || points.length < pointsCount)) await dispatch(fetchFilials(null, true));
        };
        
        getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClickSort = (newFiled) => {
        const { field, sort } = _sort;
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort({field: _sort.field, sort: newSort});
        } else {
            setSort({field: newFiled, sort: 'ASC'});
        }
    }

    const onChangeDateSelect = (e) => {
        if (e && e.min && e.max) {
            const updated = { ...filters};
            updated.created_at_gte = e.min;
            updated.created_at_lte = e.max;
            dispatch(setReportsFilters('stagesOrders', updated));
        }
    }

    const setDetail = (field) => (data) => {
        const updated = { ...renderDetail, [field]: data};
        setRenderDetail(updated);
    }

    const setFilters = (field) => (data) => {
        const updated = { ...filters, [field]: data};
        dispatch(setReportsFilters('stagesOrders', updated));
    }

    const onSearch = () => {
        dispatch(fetchReportRevenue({ withChangeStatusLog: true }, 'stagesOrders'));
        setRenderFilters(filters);
    }

    const getDateOptionsOptions = () => {
        const date_gte = moment(filters.created_at_gte);
        const date_lte = moment(filters.created_at_lte);
        const diff = date_lte.diff(date_gte, 'days');
        let value = null;
        if (diff === 0) value = 'day';
        if (diff === 6) value = 'week';
        if (diff > 6 && diff < 180) value = 'month';
        if (diff >= 180) value = 'year';

        return value ? dateOptions.filter((item) => !item.notRender || !item.notRender.includes(value)) : dateOptions;
    }

    const isDisabledSearch = () => {
        if (loading) return true;
        if ((!filters.points || filters.points.length === 0) && (!filters.regionalDirectors || filters.regionalDirectors.length === 0)) return true;
        return false;        
    }
    
    const onExport = () => {
        const { firstLvl, secondLvl } = renderDetail;
        const data = getGroupedData();
        const isRenderFirst = firstLvl && firstLvl.value !== 'none' && !isEmpty(data);
        const isRenderSecond = secondLvl && secondLvl.value !== 'none' && !isEmpty(data);

        const exportData = Object.entries(data).sort(([aKey, a], [bKey, b]) => {
            const { field, sort } = _sort;
            const aField = a[field || 'name'];
            const bField = b[field || 'name'];
            if (sort === 'DESC') {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                    return 0;
                }
                return bField - aField;  
            } else {
                if (typeof aField === 'string') {
                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                    return 0;
                }
                return aField - bField;                                                        
            }
        }).flatMap(([firstKey, firstData]) => {
            const status = firstData && firstData.name ? firstData.name : firstKey;
            if (!isRenderFirst && !isRenderSecond) {
                return { 'Статус': status, 'Среднее время': firstData.renderTime };
            }

            if (isRenderFirst && !isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    const entity = { 'Статус': status };
                    if (firstLvl.option === 'date') {
                        const dateText = firstLvl.value === 'day' ? 'Дата' : 'Период';
                        entity[dateText] = secondKey;
                    } else if (firstLvl.value === 'points') {
                        entity['Филиал'] = secondKey;
                    } else {
                        entity['День недели'] = secondKey;
                    }
                    return { ...entity, 'Среднее время': secondData.renderTime };
                });
            }

            if (!isRenderFirst && isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    const entity = { 'Статус': status };
                    if (secondLvl.option === 'date') {
                        const dateText = firstLvl.value === 'day' ? 'Дата' : 'Период';
                        entity[dateText] = secondKey;
                    } else if (secondLvl.value === 'points') {
                        entity['Филиал'] = secondKey;
                    } else {
                        entity['День недели'] = secondKey;
                    }
                    return { ...entity, 'Среднее время': secondData.renderTime };
                });
            }

            if (isRenderFirst && isRenderSecond) {
                return Object.entries(firstData.detailData).flatMap(([secondKey, secondData]) => {
                    return Object.entries(secondData.detailData).flatMap(([thridKey, thridData]) => {
                        const entity = { 'Статус': status };
                        if (firstLvl.option === 'date') {
                            const dateText = firstLvl.value === 'day' ? 'Дата' : 'Период';
                            entity[dateText] = secondKey;
                        } else if (firstLvl.value === 'points') {
                            entity['Филиал'] = secondKey;
                        } else {
                            entity['День недели'] = secondKey;
                        }

                        if (secondLvl.option === 'date') {
                            const dateText = firstLvl.value === 'day' ? 'Дата' : 'Период';
                            entity[dateText] = secondKey;
                        } else if (secondLvl.value === 'points') {
                            entity['Филиал'] = secondKey;
                        } else {
                            entity['День недели'] = secondKey;
                        }
    
                        return { ...entity, 'Среднее время': thridData.renderTime };
                    });
                });
            }
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Продажи по этапам');
        const detailText = [];
        const periodText = `${moment(renderFilters.created_at_gte).format('DD.MM.YYYY')} - ${moment(renderFilters.created_at_lte).format('DD.MM.YYYY')}`;
        detailText.push(periodText);
        if (isRenderFirst) detailText.push(`Детализация 1 - ${firstLvl.label || '-'}`);
        if (isRenderSecond) detailText.push(`Детализация 2 - ${secondLvl.label || '-'}`);
        const resultText = detailText.join(', ');
        writeFileXLSX(wb, `Отчет продажи по этапам ${resultText}.xlsx`);
    }

    const getDetailOptions = (lvl) => {
        const filteredDateOptions = getDateOptionsOptions();
        const allOptions = [...firstLvlOptions, ...filteredDateOptions];
        switch (lvl) {
            case 'secondLvl': {
                return allOptions.filter((option) => option.value === 'none' || (option.value !== renderDetail.firstLvl.value && (!option.option || option.option !== renderDetail.firstLvl.option)));
            }
            default: {
                return allOptions;
            }
        }
    }

    const renderHead = () => {
        return(
            <div className="kt-portlet__head" style={{ flexDirection: 'column', gap: '10px' }}>
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Время по этапам
                    </h3>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Поиск </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Период *</label>
                        <DateSelect 
                        isDisabled={loading}
                        isLoading={loading}
                        optionsDate={{
                            tommorow: true,
                            period: true,
                            prevWeek: true,
                            prevMonth: true,
                        }}
                        limit={{ 
                            field: 'months',
                            value: 6
                        }}
                        width={200}
                        onChange={onChangeDateSelect}
                        />
                    </div>
                    <div>
                        <label>Филиалы {(filters.regionalDirectors && filters.regionalDirectors.length > 0) ? '' : '*'}</label>
                        <PointsSelect width={200} placeholder='Филиалы' values={filters.points} setData={setFilters('points')} disabled={loading || (filters.regionalDirectors && filters.regionalDirectors.length > 0)}/>
                    </div>
                    <div style={{ width: 200 }}>
                        <label>Региональный директор {(filters.points && filters.points.length > 0) ? '' : '*'}</label>
                        <MultiSelect data={regionalDirectors} width={200} placeholder='Рег. директор' values={filters.regionalDirectors} setData={setFilters('regionalDirectors')} loading={loading} disabled={loading || (filters.points && filters.points.length > 0)}/>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button disabled={isDisabledSearch()} onClick={onSearch} style={{ marginTop: '1.9rem' }} className="btn btn-primary">Найти</button>
                        {renderData() && <button disabled={loading} onClick={onExport} style={{ marginTop: '1.9rem' }} className='btn btn-dark btn-icon-sm'>Экспорт</button>}
                    </div>
                </div>
                <div className='kt-separator kt-separator--border-dashed kt-separator--space-sm'/>
                <div><h6 style={{ color: 'black'}}> Детализация </h6></div>
                <div className="kt-portlet__head-toolbar" style={{ flexWrap: 'wrap', gap: '10px' }}>
                    <div style={{ width: 200 }}>
                        <label>Уровень 1</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('firstLvl')}
                            onChange={setDetail('firstLvl')}
                            placeholder="Уровень 1"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.firstLvl}                   
                        />
                    </div>

                    <div style={{ width: 200 }}>
                        <label>Уровень 2</label>
                        <Select
                            closeMenuOnSelect={true}
                            options={getDetailOptions('secondLvl')}
                            onChange={setDetail('secondLvl')}
                            placeholder="Уровень 2"
                            noOptionsMessage={() => 'Нет'}
                            value={renderDetail.secondLvl}                   
                        />
                    </div>
                </div>
            </div>
        );
    }


    const getGroupedData = () => {
        const { firstLvl, secondLvl } = renderDetail;
        
        const stages = [
            { title: 'Новый', status: 'new' },
            { title: 'Подтвержден', status: 'confirmed' },
            { title: 'Готовится', status: 'cook' },
            { title: 'Приготовлен', status: 'cooked' },
            { title: 'В пути', status: 'delivery' },
        ];

        const getKeys = (lvl) => {
            if (lvl.value === 'none') return [];
            
            if (lvl.value === 'points') {
                const keys = new Set();
                if (renderFilters.points && renderFilters.points.length > 0) {
                    renderFilters.points.forEach(point => {
                        const dataPoint = points.find((p) => parseInt(p.id) === parseInt(point.value));
                        if (dataPoint) return keys.add(renderAdress(dataPoint));
                    });
                } else if (renderFilters.regionalDirectors && renderFilters.regionalDirectors.length > 0) {
                    renderFilters.regionalDirectors.forEach((dir) => {
                        if (dir && dir.points && dir.points.length > 0) dir.points.forEach((point) => {
                            if (point) {
                                let pointId = point.id ? point.id : point;
                                const dataPoint = points.find((point) => point.id === pointId);
                                return keys.add(renderAdress(dataPoint));
                            }
                            keys.add('Филиал не задан');
                        });
                    })
                } else {
                    result.forEach((order) => {
                        if (order && order.point) return keys.add(renderAdress(order.point));
                        keys.add('Филиал не задан');
                    });
                }
                return Array.from(keys);
            }
            
            if (lvl.option && lvl.option === 'date') {
                const startDate = moment(renderFilters.created_at_gte);
                const endDate = moment(renderFilters.created_at_lte);
                const dateKeys = [];
    
                switch (lvl.value) {
                    case 'day': {
                        let current = startDate.clone();
                        while (current <= endDate) {
                            dateKeys.push(current.format('DD.MM.YYYY'));
                            current.add(1, 'day');
                        }
                        break;
                    }
                    case 'week': {
                        let current = startDate.clone().startOf('isoWeek');
                        let end = endDate.clone().endOf('isoWeek');
                        
                        while (current <= end) {
                            let weekStart = current;
                            let weekEnd = current.clone().endOf('isoWeek');
            
                            if (weekStart < startDate) {
                                weekStart = startDate.format('DD.MM.YYYY');
                            } else {
                                weekStart = weekStart.format('DD.MM.YYYY');
                            }
                            
                            if (weekEnd > endDate) {
                                weekEnd = endDate.format('DD.MM.YYYY');
                            } else {
                                weekEnd = weekEnd.format('DD.MM.YYYY');
                            }
                            
                            dateKeys.push(`${weekStart} - ${weekEnd}`);
                            current.add(1, 'week');
                        }
                        break;
                    }
                    case 'month': {
                        let current = startDate.clone().startOf('month');
                        let end = endDate.clone().endOf('month');
                        
                        while (current <= end) {
                            const monthStart = current.format('DD.MM.YYYY');
                            const monthEnd = current.clone().endOf('month').format('DD.MM.YYYY');
                            dateKeys.push(`${monthStart} - ${monthEnd}`);
                            current.add(1, 'month');
                        }
                        break;
                    }
                    default: break;
                }
                
                return dateKeys;
            }

            if (lvl.value === 'daysweek') return ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
            return [];
        }
        
        const createData = () => {
            const firstKeys = getKeys(firstLvl);
            const secondKeys = getKeys(secondLvl)
            
            const data = {};

            stages.forEach((stage, index) => {
                const mainData = {
                    name: stage.title,
                    count: 0,
                    totalTime: 0,
                    avgTime: 0,
                    renderTime: 0,
                    stage: index + 1,
                    detailData: {}
                };

                if (firstLvl.value !== 'none') {
                    firstKeys.forEach(firstKey => {
                        const firstData = {
                            name: firstKey,
                            count: 0,
                            totalTime: 0,
                            avgTime: 0,
                            renderTime: 0,
                            detailData: {}
                        };
    
                        if (secondLvl.value !== 'none') {
                            secondKeys.forEach((secondKey) => {
                                const secondData = {
                                    name: secondKey,
                                    count: 0,
                                    totalTime: 0,
                                    avgTime: 0,
                                    renderTime: 0,
                                    detailData: {}
                                }
    
                                firstData.detailData[secondKey] = secondData;
                            });
                        }
                    
                        mainData.detailData[firstKey] = firstData;
                    });
                }  else if (secondLvl.value !== 'none') {
                    secondKeys.forEach((secondKey) => {
                        const secondData = {
                            name: secondKey,
                            count: 0,
                            totalTime: 0,
                            avgTime: 0,
                            renderTime: 0,
                            detailData: {}
                        }
    
                        mainData.detailData[secondKey] = secondData;
                    });
                }
                data[stage.status] = mainData;
            });
            
            return data;
        };

        const getTimeOrder = (order) => {
            const time = parseInt(order.timeZone, 10) || 3;
            const baseOrderDate = order.visible_datetime || order.created_at;
            const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
            return orderDate;
        }

        const getDateKeyOrders = (order, levelType) => {
                const orderDate = getTimeOrder(order);
                
                switch(levelType) {
                    case 'day': {
                        return orderDate.format('DD.MM.YYYY');
                    }
                    case 'week': {
                        const startDate = moment(renderFilters.created_at_gte);
                        const endDate = moment(renderFilters.created_at_lte);
                        let weekStart = orderDate.clone().startOf('isoWeek');
                        let weekEnd = orderDate.clone().endOf('isoWeek');
        
                        if (weekStart < startDate) {
                            weekStart = startDate.format('DD.MM.YYYY');
                        } else {
                            weekStart = weekStart.format('DD.MM.YYYY');
                        }
                    
                        if (weekEnd > endDate) {
                            weekEnd = endDate.format('DD.MM.YYYY');
                        } else {
                            weekEnd = weekEnd.format('DD.MM.YYYY');
                        }
                        
                        return `${weekStart} - ${weekEnd}`;
                    }
                    case 'month': {
                        const monthStart = orderDate.startOf('month').format('DD.MM.YYYY');
                        const monthEnd = orderDate.endOf('month').format('DD.MM.YYYY');
                        return `${monthStart} - ${monthEnd}`;
                    }
                    default: {
                        return null;
                    }
                }
            };
    
        const getKeyByLevel = (order, levelType) => {
            if (levelType === 'points') {
                return order.point ? renderAdress(order.point) : 'Филиал не задан';
            } else if (levelType === 'daysweek') {
                const time = parseInt(order.timeZone, 10) || 3;
                const baseOrderDate = order.visible_datetime || order.created_at;
                const orderDate = moment.utc(baseOrderDate).add(time, 'hours');
                
                const day = moment(orderDate).day();
                let dayIndex = day === 0 ? 6 : day - 1;
                const weekDays = ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'];
                return weekDays[dayIndex];
            } else {
                return getDateKeyOrders(order, levelType);
            }
        };

        const calculateAvgTime = (detailData) => {
            Object.keys(detailData).forEach(key => {
                const item = detailData[key];
                
                if (item.totalTime > 0 && item.count > 0) {
                    const avgTime = item.totalTime / item.count;
                    const avgDuration = moment.duration(avgTime);

                    const hours = Math.floor(avgDuration.asHours());
                    const minutes = avgDuration.minutes();
                    const seconds = avgDuration.seconds();
                    const formatted = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
                    item.avgTime = avgTime;
                    item.renderTime = formatted;
                }
                if (item.detailData && Object.keys(item.detailData).length > 0) calculateAvgTime(item.detailData);
            });
            return detailData;
        };
        
        const fillNullData = (data) => {
            const updated = JSON.parse(JSON.stringify(data));
            
            (result || []).forEach((order) => {    
                const firstKey = firstLvl.value !== 'none' ? getKeyByLevel(order, firstLvl.value) : null;
                const secondKey = secondLvl.value !== 'none' ? getKeyByLevel(order, secondLvl.value) : null;

                let changeStatusLog = [];
                if(order.changeStatusLog) {
                    if(typeof order.changeStatusLog === 'string') {
                        changeStatusLog = JSON.parse(order.changeStatusLog)
                    } else {
                        changeStatusLog = order.changeStatusLog
                    }
                }

                let logs = Array.isArray(changeStatusLog) ? changeStatusLog : Object.values(changeStatusLog);
                logs = logs.map(change => {
                    const parsedDate = moment(change.date, ['DD.MM.YYYY HH:mm', 'DD.MM.YYYY HH:mm:ss']);
                    return { ...change, parsedDate };
                }).filter(item => item.parsedDate.isValid()).sort((a, b) => a.parsedDate - b.parsedDate);

                logs.unshift({
                    status: "new",
                    parsedDate: getTimeOrder(order),
                    user: order.author,
                });

                changeStatusLog = logs;

                if (!isEmpty(changeStatusLog)) {
                    changeStatusLog.forEach((change, index) => {
                        const stageKey = change.status ? change.status : 'Не определено';
                        if (updated[stageKey]) {
                            updated[stageKey].count += 1;

                            const currentDate = change.parsedDate;
                            let nextDate = moment();
                            if (index === changeStatusLog.length - 1) {
                                if (stageKey === 'done' || stageKey === 'cancel' || stageKey === 'written-off') {
                                    nextDate = currentDate;
                                } else {
                                    nextDate = moment();
                                }
                            } else {
                                nextDate = changeStatusLog[index + 1].parsedDate;
                            }
                            const duration = nextDate.diff(currentDate);
                            updated[stageKey].totalTime += duration;

                            if (firstKey) {
                                if (!updated[stageKey].detailData[firstKey]) {
                                    updated[stageKey].detailData[firstKey] = {
                                        name: firstKey,
                                        count: 0,
                                        totalTime: 0,
                                        avgTime: 0,
                                        renderTime: 0,
                                        detailData: {}
                                    };
                                }
                                const firstLvlData = updated[stageKey].detailData[firstKey];
                                firstLvlData.count += 1;
                                firstLvlData.totalTime += duration;
                                
                                if (secondKey) {
                                    if (!firstLvlData.detailData[secondKey]) {
                                        firstLvlData.detailData[secondKey] = {
                                            name: secondKey,
                                            count: 0,
                                            totalTime: 0,
                                            avgTime: 0,
                                            renderTime: 0,
                                            detailData: {}
                                        };
                                    }
                                    const secondData = firstLvlData.detailData[secondKey];
                                    secondData.count += 1;
                                    secondData.totalTime += duration;
                                }
                            } else if (secondKey) {
                                if (!updated[stageKey].detailData[secondKey]) {
                                    updated[stageKey].detailData[secondKey] = {
                                        name: secondKey,
                                        count: 0,
                                        totalTime: 0,
                                        avgTime: 0,
                                        renderTime: 0,
                                        detailData: {}
                                    };
                                }
                                const secondData = updated[stageKey].detailData[secondKey];
                                secondData.count += 1;
                                secondData.totalTime += duration;
                            }
                        }
                    })
                }
            });

            return calculateAvgTime(updated);
        };
        
        const data = createData();
        const filledData = fillNullData(data);
        return filledData;
    };

    const renderTable = () => {
        const { field, sort } = _sort;
        const firstLvl = renderDetail.firstLvl.value;
        const secondLvl = renderDetail.secondLvl.value;
        const data = getGroupedData();

        return(
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded'>
                <table className='kt-datatable__table' style={{ width: '100%'}}>
                    <thead className='kt-datatable__head' style={{ position: 'sticky' }}>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell' style={{ width: '100px' }}>
                                <SortButton 
                                className={field === 'stage' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='id' onClick={() => handleClickSort('stage')} 
                                up={field === 'stage' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}>
                                <SortButton 
                                className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Статус' onClick={() => handleClickSort('name')} 
                                up={field === 'name' && sort === 'ASC'}
                                />
                            </th>
                            <th className='kt-datatable__cell' style={{ width: '250px' }}>
                                <SortButton 
                                className={field === 'avgTime' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} 
                                text='Ср. вермя' 
                                onClick={() => handleClickSort('avgTime')} 
                                up={field === 'avgTime' && sort === 'ASC'}
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody className='kt-datatable__body'>
                        {Object.entries(data)
                        .sort(([aKey, a], [bKey, b]) => {
                            const { field, sort } = _sort;
                            const aField = a[field || 'name'];
                            const bField = b[field || 'name'];
                            if (sort === 'DESC') {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() > bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() < bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return bField - aField;  
                            } else {
                                if (typeof aField === 'string') {
                                    if(aField.toLowerCase() < bField.toLowerCase()) return -1;
                                    if(aField.toLowerCase() > bField.toLowerCase()) return 1;
                                    return 0;
                                }
                                return aField - bField;                                                        
                            }
                        })
                        .map(([key, item]) => <ItemRow item={item} firstLvl={firstLvl} secondLvl={secondLvl}/>)}
                    </tbody>
                </table>
            </div>
        );
    }

    const renderData = () => {
        if ((!result || result.length === 0) && (!renderFilters.points || renderFilters.points.length === 0) && (!renderFilters.regionalDirectors || renderFilters.regionalDirectors.length === 0)) return false;
        return true;       
    }

    const renderBody = () => {
        if (loading || pointLoading) return <div style={styles.loading}><Loader /></div>;        

        if (!renderData()) return <div className='kt-portlet'> 
            <div className='kt-portlet__body'>Нет данных</div> 
        </div>

        return(
        <div className="kt-portlet">
            <ErrorContainer field="stagesOrders" style={{ margin: '20px 20px 0px 20px' }} hasCloseButton={true}/>
            <div className='kt-portlet__body'>
            {renderTable()}
            </div>
        </div>
        );
    }

    return (
        <>
            <div className="kt-portlet">
                {renderHead()}
            </div>
            {renderBody()}
        </>         
    );
}